import { render, staticRenderFns } from "./entry-point.vue?vue&type=template&id=4bd114f8&scoped=true&"
import script from "./entry-point.vue?vue&type=script&lang=js&"
export * from "./entry-point.vue?vue&type=script&lang=js&"
import style0 from "./entry-point.vue?vue&type=style&index=0&id=4bd114f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd114f8",
  null
  
)

export default component.exports